import FbButton from 'components/FbUI/FbButton'
import { HiOutlineCheckCircle } from 'react-icons/hi'

function Verified() {
  return (
    <div className="w-96 flex-shrink-0">
      <div className="text-[22px] font-light text-new-company-gray-500">
        Welcome to{' '}
        <span className="text-new-company-green-dark font-semibold">
          First Bite
        </span>
      </div>

      <div className="mt-8 flex flex-col items-center text-center">
        <div className="w-16 h-16 rounded-full bg-new-company-pistachio-light flex items-center justify-center mb-4">
          <HiOutlineCheckCircle className="w-10 h-10 text-new-company-green-dark" />
        </div>

        <h1 className="text-[20px] font-semibold mb-2">Email verified</h1>

        <p className="text-gray-600 mb-6">
          Your email has been successfully verified. You can now log in to your
          account.
        </p>

        <FbButton
          onClick={() => (window.location.href = '/login')}
          className="w-full"
        >
          Go to Login
        </FbButton>
      </div>
    </div>
  )
}

export default Verified
